import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './AddLocation.css';
import messages from '../../../locale/messages';
import LocationForm from '../../../components/SiteAdmin/Location/LocationForm/LocationForm';

class AddLocation extends Component {
    render() {
        return (
            <div>
                <div className={cx('heading', 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.addLocationHeading} />
                </div>
                <div>
                    <LocationForm initialValues={{ isActive: 'true', restrictDropOff: 'false' }} />
                </div>
            </div>
        );
    }
}

export default withStyles(s)(AddLocation);
